import { errorLoading, loaded, responseHandler, errorGetStatus, tokenInterceptor } from '../manager/HttpManager'

import Constants from '../constants/Constants'

let urlChatServer

export const chatWS = (state = { rooms: [], room: {} }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.CHAT.SET_ROOMS:
      return Object.assign({}, state, { rooms: action.datas })
    case Constants.ActionsConstants.CHAT.SET_ROOM:
      return Object.assign({}, state, { room: action.datas })
    case Constants.ActionsConstants.CHAT.CLEAR_ROOMS:
      return Object.assign({}, state, { rooms: [] })
    default:
      return state
  }
}

export const setRooms = (data) => {
  return {
    type: Constants.ActionsConstants.CHAT.SET_ROOMS,
    datas: data,
  }
}

export const clearRooms = (data) => {
  return {
    type: Constants.ActionsConstants.CHAT.CLEAR_ROOMS,
  }
}

export const setRoom = (data) => {
  return {
    type: Constants.ActionsConstants.CHAT.SET_ROOM,
    datas: data,
  }
}

function _makeHeader (apiKey, secretKey) {
  return {
    'Content-Type': 'application/json',
    'x-api-key': apiKey,
    'x-secret-key': secretKey,
  }
}

export function chatCalls (dispatch, sectionid, apiKey, secretKey, room, url) {
  function fetchRooms () {
    // console.log('ChatWS : fetchRooms apiKey=' + apiKey + ' secretKey='+secretKey)
    // /api/room/list
    urlChatServer = url.substring(url.length-1) === '/' ? url.substring(0, url.length-1) : url
    urlChatServer = urlChatServer.replace('wss', 'https')

    let method = Constants.UrlsConstants.chat.listRoom

    fetch(urlChatServer+method, {
      method: 'GET',
      headers: _makeHeader(apiKey, secretKey),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        if (data.success === true) {
          let rooms = data.data
          rooms.sort(function (r1, r2) {
            if (r1 && r2 && r1.id && r2.id) {
              if (r1.id > r2.id) return 1
              else if (r1.id < r2.id) return -1
              else return 0
            } else {
              return 0
            }
          })

          dispatch(setRooms(rooms))
        } else {
          dispatch(errorLoading('Error.Croutons.errorLoadingData'))
        }
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          console.log('Cle API incorrect')
          dispatch(errorLoading('Error.Croutons.authExpired'))
          // window.location.href='/'
        }
      })
  }

  function detailRoom () {
    // console.log('ChatWS : detailRoom apiKey=' + apiKey + ' secretKey='+secretKey + ' roomId' + room.id)
    // /api/room/get
    urlChatServer = url.substring(url.length-1) === '/' ? url.substring(0, url.length-1) : url
    urlChatServer = urlChatServer.replace('wss', 'https')

    let method = Constants.UrlsConstants.chat.subscription

    fetch(urlChatServer+method+'?roomId='+room.id, {
      method: 'GET',
      headers: _makeHeader(apiKey, secretKey),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        if (data.success === true) {
          dispatch(setRoom(data.data))
        } else {
          dispatch(errorLoading('Error.Croutons.errorLoadingData'))
        }
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          console.log('Cle API incorrect')
          dispatch(errorLoading('Error.Croutons.authExpired'))
          // window.location.href='/'
        }
      })
  }

  function subscribeGroup () {
    // console.log('ChatWS : subscribeGroup apiKey=' + apiKey + ' secretKey='+secretKey + ' roomId' + room.id)
    // /api/room/get
    urlChatServer = url.substring(url.length-1) === '/' ? url.substring(0, url.length-1) : url
    urlChatServer = urlChatServer.replace('wss', 'https')

    let method = Constants.UrlsConstants.chat.subscribe

    room.groups.forEach((group) => {
      fetch(urlChatServer+method+'?roomId='+room.id+'&groupId='+group.id, {
        method: 'GET',
        headers: _makeHeader(apiKey, secretKey),
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        if (data.success === true) {
          dispatch(setRoom(data.data))
        } else {
          dispatch(errorLoading('Error.Croutons.errorLoadingData'))
        }
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          console.log('Cle API incorrect')
          dispatch(errorLoading('Error.Croutons.authExpired'))
          // window.location.href='/'
        }
      })
    })
  }

  function addUpdateRoom () {
    // /api/room/add
    urlChatServer = url.substring(url.length-1) === '/' ? url.substring(0, url.length-1) : url
    urlChatServer = urlChatServer.replace('wss', 'https')

    let method = Constants.UrlsConstants.chat.addRoom
    if (room.id) {
      method = Constants.UrlsConstants.chat.updateRoom
    }

    fetch(urlChatServer+method, {
      method: 'POST',
      headers: _makeHeader(apiKey, secretKey),
      body: JSON.stringify(room),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchRooms()
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          console.log('Cle API incorrect')
          dispatch(errorLoading('Error.Croutons.authExpired'))
          // window.location.href='/'
        }
      })
  }

  function deleteRoom () {
    urlChatServer = url.substring(url.length-1) === '/' ? url.substring(0, url.length-1) : url
    urlChatServer = urlChatServer.replace('wss', 'https')

    // /api/room/remove
    let method = Constants.UrlsConstants.chat.removeRoom

    fetch(urlChatServer+method+'?id='+room.id, {
      method: 'GET',
      headers: _makeHeader(apiKey, secretKey),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchRooms()
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          console.log('Cle API incorrect')
          dispatch(errorLoading('Error.Croutons.authExpired'))
          // window.location.href='/'
        }
      })
  }

  return {
    fetchRooms,
    detailRoom,
    addUpdateRoom,
    deleteRoom,
    subscribeGroup,
  }
}
